"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiSelect = void 0;
exports.MuiSelect = {
    styleOverrides: {
        filled: {
            height: '100%',
            boxSizing: 'border-box',
        },
    },
};
//# sourceMappingURL=MuiSelect.js.map